export const validateLoginForm = ({ old, values }: any) => {
  const requiredFields = ['email', 'password'];
  let found = false;
  const state: any = {
    email: { filled: false, message: '' },
    password: { filled: false, message: '' },
  };

  for (const key in old) {
    if (requiredFields.includes(key)) {
      if (!values[key]) {
        state[key] = { filled: true, message: 'empty field' };
        found = true;
        continue;
      } else if (key === 'email') {
        if (!values[key].includes('@') || !values[key].includes('.')) {
          state[key] = {
            filled: true,
            message: 'incorrect email address',
          };
          found = true;
          continue;
        }
      }
    }
  }

  return { state, preventChange: found };
};
